import React from "react";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import OrderTag from "@/enum/OrderTag";

interface LuckyMoneyProps {
    orderTags: OrderTag[];
}

/**
 * 红包
 */
const LuckyMoney: React.FC<LuckyMoneyProps> = observer(function (props) {
    const { orderTags } = props;

    /**
     * 是否显示红包
     */
    const hasLuckyMoney = orderTags?.find((tag) => tag === OrderTag.LUCKY_MONEY);

    if (!hasLuckyMoney) {
        return null;
    }

    return (
        <Tooltip title="买家使用平台或商家红包付款">
            <span className="lucky-money">
                <img
                    style={{ width: 13, height: "auto" }}
                    src="https://img.alicdn.com/imgextra/i2/54458674/O1CN01ycOSed2DwkVkU9qYn_!!54458674.png"
                    alt=""
                />
            </span>
        </Tooltip>
    );
});

export default LuckyMoney;
